export const supportedLanguages = ['bg', 'en', 'nl', 'tr', 'pl'] as const;
export type AppLanguage = (typeof supportedLanguages)[number];

export const isAppLanguage = (language: string): language is AppLanguage =>
  (supportedLanguages as readonly string[]).includes(language);
